
import {
	Math as THREEMath,
	Vector3,
	//Color,
	//TextureLoader,
	//Mesh,
	//MeshLambertMaterial,
	//MeshBasicMaterial,
	//MeshStandardMaterial,
	//CubeGeometry,
	//PointLightHelper,
	//HemisphereLightHelper,
	//SpotLightHelper,
	//DirectionalLightHelper,
	//AxesHelper,
	//ObjectLoader,
	Matrix3,
	Object3D,
	//Box3,
	//BoxHelper,
	//VideoTexture,
	//MeshPhongMaterial
} from '../../../../src/js/three.module.js';

//import { ObjectLoader } from '../../../utils/object-loader.js';

import {
	//rotateAroundWorldAxis,
	roundVector
} from '../../GameTools.js';

//import { ObjectClickHandler }       from '../../../utils/object-click-handler.js';

//import { CommentsHandler }      from '../../services/CommentsService.js';
//import UserActionHistoryService from '../../services/UserActionHistoryService.js';
//import { buildMaterialParameters, createDefaultMaterial, createMaterialByImageUrl, createTextureByImageUrl } from './utils.js';

//import { createHemisphereGroundColor } from '../../../utils/colors.js';

import { GameSceneService } from '../../services/game-scene.service.js';

import { BaseAdditionalObject } from './base-additional-object.js';

import { getObjectLoader } from '../../../utils/loaders/loader-manager.js';

export class AdditionalObjectJSON extends BaseAdditionalObject {
    constructor( json ) {

        /** @note Luodaan container, johon saatu parsittu json tuupataan. Vaihdetaan parsitun uuid (jottei tule useita samoja). */
        var mesh    = new Object3D();
        var $$inner = (/* new ObjectLoader() */ getObjectLoader()).parse( json );
        var uuid    = $$inner.uuid; // Pistetään talteen, jotta tunnistetaan oletettavasti identtiset
        
        $$inner.uuid = THREEMath.generateUUID();

        mesh.add( $$inner );

        super( mesh );

        this.type = "json";
        this.opts = {
            uuid  :  $$inner.uuid, // Pistetään talteen, jotta tunnistetaan oletettavasti identtiset
            json  : json,
            scale : 1
        };
        
        this.$$inner = $$inner;

        this.setWireframe();

        this.mesh.add( this.wireframe );

        this.refreshWireframe();
        this.optsChanged();
        this.onSelectChange();
    }

    static genHash( obj ) {

        return obj.type +
            "-" + obj.opts.json.object.uuid +
            "-" + obj.opts.scale;
    }

    setJson( json ) {
        this.opts.json = json;
        var obj = (/* new ObjectLoader() */ getObjectLoader()).parse( json );
        this.opts.uuid = obj.uuid; // Pistetään talteen, jotta tunnistetaan oletettavasti identtiset

        this.$$inner.children.forEach(function( child ) { child.parent.remove( child ); });
        this.mesh.remove( this.$$inner );

        this.$$inner = obj;
        this.mesh.add( this.$$inner );

        this.optsChanged();
        this.refreshWireframe();
    }

    /**
     * Päivitetään objektin wireframen sijainti ja koko geometrian mukaiseksi.
     * Tarpeellinen siis vain geometrian muuttuessa, eli käytännössä latautuessa.
     */
    refreshWireframe() {
        // Tehdään oletus, että objektin geometria on asemoitu s.e. "ylös" että .up on y=+1 sekä verteksit on asetettu tason y=0 yläpuolelle.

        if (this.wireframe.setFromObject) {
            // Huolehditaan, että wireframe noudattaa objektin muotoa
            this.wireframe.setFromObject( this.$$inner );
        }

        // Normalisoidaan wirframen verteksit origon ympärille
        this.wireframe.geometry.center();

        this.wireframe.geometry.computeBoundingBox();

        // Varmistetaan, että origo on origo
        this.wireframe.position.set( 0, 0, 0 );

        /**
         * Koska kohdeobjektin keskusta ja wireframen keskusta halutaan samaan sijaintiin
         * ja oletetaan, että objekti on aina "lattialla", korjataan sijaintia ylöspäin.
         * Objektin tosiasiallinen sijainti on yleensä pinnalla.
         * Koska boundingBox on laskettu keskitetystä geometriasta ja siirtää halutaan vain puolet korkeudesta, 
         * voidaan käyttää boundingBoxin yläreunaa siirron määränä.
         */
        this.wireframe.position.y += this.wireframe.geometry.boundingBox.max.y;

        this.wireframe.updateMatrix();

        if (this.wireframe.geometry.boundingBox) {
            this.size = this.size || new Vector3();
            this.wireframe.geometry.boundingBox.getSize( this.size );
        }
    }

    optsChanged() {
        this.scale = parseFloat( this.opts.scale );

        this.wireframe.scale.copy( this.mesh.scale.set( this.scale, this.scale, this.scale ));

        this.mesh.updateMatrix();
        this.refreshHash();
    }

    refreshHash() {

        var old_hash = this.obj_hash;

        this.obj_hash = AdditionalObjectJSON.genHash( this );

        if (old_hash != this.obj_hash) {
            let additionalObjectsService = this.service;
            additionalObjectsService.objectHashUpdateNeeded = true;
            // console.log("AdditionalObjectJSON.refreshHash() :: Hash changed!", old_hash, this.obj_hash, this);
        }
    }

    onSelectChange() {
        if (this.wireframe) this.wireframe.visible = (GameSceneService.getInstance().editor && this.selected) ? true : false;
    }

    /**
     * Sijoitetaan objekti pinnalle, joka on saatu Raycasteria käyttäen
     *
     * @param {Object} [intersect] - Raycasterin säteen kohtauspiste
     */
    setPlaceByIntersect( intersect ) {

        const gameService = GameSceneService.getInstance();

        var point, normal;

        /**
         * Hankitaan kohdepisteen sijainti sekä pinnan normaali
         */
        if (!intersect) {

            if (this.$lastIntersect) {
                intersect = this.$lastIntersect;
                normal    = intersect.face.normal.clone().applyMatrix3( new Matrix3().getNormalMatrix( intersect.object.matrixWorld )).normalize();
                point     = intersect.point;
            } else {
                return console.error("Invalid Argument: no argument intersect nor $lastIntersect");
            }

        } else {

            if (intersect instanceof Vector3) {
                point = intersect;
            } else {
                normal              = intersect.face.normal.clone().applyMatrix3( new Matrix3().getNormalMatrix( intersect.object.matrixWorld )).normalize();
                point               = intersect.point;
                this.$lastIntersect = intersect;
            }
        }


        // Ei tiedossa pistettä johon ollaan asettamassa!
        if (!point) return console.warn( "AdditionalObjectJSON.setPlaceByIntersect :: Unable to set place. No point available!" );


        // Halutaanko salllia sijainnin asettaminen liukuvasti, vai pyöristetäänkö sitä
        var lockSize = gameService.opts.game.lockToGrid == "world" && gameService.opts.game.lockGridSize || false;


        // Varmistetaan, että normaali (tuleva asento) on soveltuva
        if (normal) {
            try {

                // Ei haluta, että tuleva asento on "poispäin" pelaajasta (kamerasta), joten jos näin on, käytetäänkin sen käänteisvektoria
                if (player.camera.position.clone().sub( point ).normalize().dot( normal ) < 0) {
                    normal.multiplyScalar( -1 );
                }

            } catch (e) { console.error(e); }
        } else {
            normal = new Vector3( 0, 0, 1 ).applyEuler( this.mesh.rotation );
        }


        /**
         * Varmistetaan oletettavasti halutun kohdesijainnin normaalista,
         * että objekti voidaan asettaa kyseiselle pinnalle.
         *
         *  _  <- 
         * /   <- Katto viistää paljon, normaalivektori osoittaa paljon tai melko paljon alaspäin (y < 0)
         * |
         * |   <- Seinällä normaalivektori lähes vaakasuunnassa
         * |
         * \_  <- Lattia viistää paljon, normaalivektori osoittaa paljon tai melko paljon ylöspäin (y > 0)
         */
        if (normal.y <= -0.5) {
            // Pinta viistää reilusti alaspäin -> Pinta onkin katto
            
            if (!this.availPlanes.ceiling) return console.warn("Could not put obj on the roof");

            if (lockSize) point.copy( roundVector( point.clone(), lockSize/100 ).setY( point.y ));

        } else if (normal.y < 0.5) {
            // Pinta ei viistä reilusti alaspäin eikä ylöspäin -> Oletetaan seinäksi

            if (!this.availPlanes.wall) return console.warn("Could not put obj on the wall");

            if (lockSize) point.setY( roundVector( point.clone(), lockSize/100 ).y );

        } else if (normal.y >= 0.5) {

            // Pinta viistää reilusti ylöspäin -> Oletetaan katoksi!
            
            if (!this.availPlanes.floor) return console.warn("Could not put obj on the floor");

            if (lockSize) point.copy( roundVector( point.clone(), lockSize/100 ).setY( point.y ));

        }


        // Jos objektia on asetettu oletuksena poispäin pinnasta, siirretään oletettavasti normaalin suuntaisesti.
        if (this.z_offset) point.addScaledVector( normal, this.z_offset );

        /**
         * Sijoitetaan objekti uuteen sijaintiinsa!
         */
        this.mesh.position.copy( point );


        // Merkitään talteen tieto käytetystä normaalista
        this.$lastNormal = normal;


        /** @TODO: Käänetään uuden normaalin suuntaisesti, jos ei ole aiemmin normaalia tai ero aiempaan on tarpeeksi suuri */
        if (Math.abs(1-this.$lastNormal.dot(normal)) > 0.001) {
            console.log("AdditionalObjectJSON.setPlaceByIntersect :: Need to rotate to normal!", this.$lastNormal, "->", normal);
            this.$lastNormal = normal;
            this.mesh.quaternion.setFromUnitVectors( this.mesh.up, normal );
        }

        gameService.shadowsNeedsUpdate = true;

        return point;
    }

}